import {CacheRules} from "./cache-rules";
import {Record} from "./record";
import {TypeUtils} from "../../../../../shared/utils/type-utils";

export class CloudflareData {
  public ownershipVerificationRecords: Record;
  public sslVerificationRecords: Record[];
  public dcvVerificationRecords: Record[];
  public cfRecords: Record[];
  public verificationErrors: any[];
  public hostname: string;
  public hostnameStatus: string;
  public sslStatus: string;
  public cfStatus: string;
  public txtStatus: string;
  public originalRecord: string;
  public cacheRules: CacheRules;
  public hasDcvRecord: boolean;

  constructor(data, withCacheData) {
    this.ownershipVerificationRecords = !TypeUtils.isEmpty(data.ownership_verification_records) ? new Record(data.ownership_verification_records, data.hostname) : null;
    this.sslVerificationRecords = data.ssl_verification_records && data.ssl_verification_records.length && data.ssl_verification_records.map(record => new Record(record, data.hostname));
    this.dcvVerificationRecords = data.dcv_delegation_verification_records && data.dcv_delegation_verification_records.length && data.dcv_delegation_verification_records.map(record => new Record(record, data.hostname));
    this.cfRecords = data.cf_records && data.cf_records.length && data.cf_records.map(record => new Record(record, data.hostname));
    this.hostname = data.hostname;
    this.verificationErrors = data.verification_errors;
    this.hostnameStatus = data.hostname_status;
    this.sslStatus = data.ssl_status;
    this.cfStatus = data.cf_status;
    this.txtStatus = data.txt_status;
    this.originalRecord = data.original_record;
    this.cacheRules = withCacheData ? new CacheRules(data.cache_rules) : null;
    this.cfStatus = data.cf_status;
    this.hasDcvRecord = !!data.has_dcv_record;
  }
}


